import { render, staticRenderFns } from "./Coopmode.vue?vue&type=template&id=147e4826&scoped=true&"
import script from "./Coopmode.vue?vue&type=script&lang=js&"
export * from "./Coopmode.vue?vue&type=script&lang=js&"
import style0 from "./Coopmode.vue?vue&type=style&index=0&id=147e4826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147e4826",
  null
  
)

export default component.exports